import { ChevronRight } from 'lucide-react'

interface ShowMoreCardProps {
  onClick: () => void
}

/**
 * Последняя плитка в превью категории: открывает раздел целиком.
 *
 * Заменяет кнопку «Все» в шапке блока — она стояла далеко от места, где список
 * обрывается, и терялась.
 */
const ShowMoreCard = ({ onClick }: ShowMoreCardProps) => (
  <button type="button" className="show-more-card" onClick={onClick}>
    <span className="show-more-card__label">Ещё</span>
    <ChevronRight size={18} strokeWidth={2.5} aria-hidden />
  </button>
)

export default ShowMoreCard
